import PropTypes from 'prop-types'

export const Alert = ({ type = 'info', title, message, children, onClose, className = '' }) => {
  if (!message && !children) return null

  const typeStyles = {
    success: 'bg-green-900/20 border-green-500/30 text-green-400',
    error: 'bg-red-900/20 border-red-500/30 text-red-400',
    warning: 'bg-yellow-900/20 border-yellow-500/30 text-yellow-400',
    info: 'bg-blue-900/20 border-blue-500/30 text-blue-400',
  }

  const textStyles = {
    success: 'text-green-300',
    error: 'text-red-300',
    warning: 'text-yellow-300',
    info: 'text-blue-300',
  }

  return (
    <div
      className={`mb-4 p-4 border rounded-lg ${typeStyles[type] || typeStyles.info} ${className}`}
      role="alert"
      aria-live="polite"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          {title && <p className="font-medium mb-1">{title}</p>}
          {message && (
            <p className={`text-sm ${title ? textStyles[type] || textStyles.info : ''}`}>
              {message}
            </p>
          )}
          {children && (
            <div className={`text-sm ${title ? textStyles[type] || textStyles.info : ''}`}>
              {children}
            </div>
          )}
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-3 flex-shrink-0 hover:opacity-75 transition-opacity focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-gray-900 rounded"
            aria-label="Close alert"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  className: PropTypes.string,
}

export default Alert
